export const SET_SENDER_COUNTRY_FIELD = 'SET_SENDER_COUNTRY_FIELD';
export const UPDATE_IP_COUNTRY_CODE_REQUEST = 'UPDATE_IP_COUNTRY_CODE_REQUEST';
export const UPDATE_IP_COUNTRY_CODE_SUCCESS = 'UPDATE_IP_COUNTRY_CODE_SUCCESS';
